export interface InventoryDispatchRow {
  id: string
  code: string
  dispatchDate: string // yyyy-mm-dd
  sourceWarehouse: string
  destinationWarehouse: string
  /** API ReceivingStatus: 1 Pending, 2 Transferred, 3 Received, 4 Cancel */
  receivingStatus?: number
}

export interface InventoryDispatchLine {
  id: string
  itemId: string
  batchId: string
  previousQuantity: number
  quantityDispatched: number
  balanceQuantity: number
}

export interface InventoryDispatch {
  id: string
  code: string
  dispatchDate: string
  sourceWarehouseId: string
  destinationWarehouseId: string
  /** Branch whose warehouses populate destination warehouse (API: GetWarehousesByBranchId for that branch) */
  destinationBranchId?: string
  sourceWarehouseName?: string
  destinationWarehouseName?: string
  remarks: string
  /** API ReceivingStatus: 1 Pending, 2 Transferred, 3 Received, 4 Cancel */
  receivingStatus?: number
  attachmentName?: string
  /** Data URL (base64) of the uploaded attachment, persisted so the file can
   *  be re-opened from edit screen even after a page refresh (we don't get
   *  a server URL back from the dispatch save endpoint). */
  attachmentDataUrl?: string
  lines: InventoryDispatchLine[]
}

export function newDispatchLine(): InventoryDispatchLine {
  return {
    id: `${Date.now()}-${Math.random().toString(36).slice(2, 9)}`,
    itemId: '',
    batchId: '',
    previousQuantity: 0,
    quantityDispatched: 0,
    balanceQuantity: 0,
  }
}

